<script>
    import { OS } from "../stores.js";
    import FaApple from "svelte-icons/fa/FaApple.svelte";
    import FaAndroid from "svelte-icons/fa/FaAndroid.svelte";
    import { createEventDispatcher } from "svelte";
    import { fade } from "svelte/transition";
    import { gotoApp } from "../utils.js";
    import FaRegCaretSquareDown from 'svelte-icons/fa/FaRegCaretSquareDown.svelte'

    const dispatch = createEventDispatcher();

    function close() {
        dispatch("close");
    }

</script>

<div class="overlay" transition:fade={{ duration: 200 }}>
    <div class="bg" on:mousedown|stopPropagation>
        <p>לחוויה משופרת</p>
        <div class="buttons">
            <button on:click={gotoApp}>
                <div class="osIcon">
                    {#if $OS == 'iOS'}
                        <FaApple />
                    {:else if $OS == 'Android'}
                        <FaAndroid />
                    {/if}
                </div>
                <div class="title">התקנת האפליקציה מהחנות</div>
            </button>
        </div>
    </div>
    <p class="noThanks" on:mousedown={close}>לא תודה</p>
</div>

<style>
    .noThanks {
        margin-top: 10px;
        font-size: 16px;
        cursor: pointer;
    }

    .osIcon {
        width: 30px;
        min-width: 30px;
        min-height: 30px;
    }

    .overlay {
        background: #0008;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        flex-direction: column;
    }

    .bg {
        background: white;
        border-radius: 4px;
        max-width: 310px;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 18px;
        padding: 25px;
        box-shadow: 0 30px 40px -15px black;
    }

    .bg > p {
        margin: 0;
        margin-bottom: 15px;
    }

    .buttons {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .overlay > p {
        margin-bottom: 22px;
        color: #ffffffdd;
    }

    button {
        padding: 12px 20px;
        color: white;
        margin: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 4px;
        cursor: pointer;
        background: var(--blue1);
        border: none;
        font-size: 16px;
        gap: 16px;
        width: 100%;
    }

</style>
